<template>
	<div :class="isMobile ? 'p-col-12 p-text-center' : 'p-col-12 p-text-left'">
		<h3 v-if="!isMobile" class="p-text-bold p-my-0" style="text-decoration: underline">
			Summary
		</h3>

		<div class="p-mt-3">
			<h4 class="p-text-bold p-my-0">Membership & Location</h4>

			<span v-if="store.Membership.isMember === 'No'" class="p-my-0">
				Membership:
				<span class="p-primary-color p-text-bold">
					{{
						store.Membership.becomeMember === "familyMembership"
							? "$70.00 (Family Membership)"
							: store.Membership.becomeMember === "singleMembership"
							? "$55.00 (Single Membership)"
							: "No Membership"
					}}
				</span>
			</span>

			<div>
				<span class="p-my-0">
					Location: {{ store.ProgramSelection.location }}
				</span>
			</div>
		</div>

		<h4 class="p-text-bold p-mt-3 p-mb-0">Programs</h4>

		<div
			v-for="entry in store.ChildInfo"
			:key="entry.childNumber"
			class="p-mb-2"
		>
			<span class="p-text-bold">
				{{ entry.firstName }} {{ entry.lastName }}:
				<span class="p-primary-color p-text-bold">
					${{ entry.childTotalAmount.toFixed(2) }}
				</span>
			</span>

			<div v-if="entry.selectedPrograms !== null">
				<div v-for="program in entry.selectedPrograms" :key="program.id">
					<span class="p-p-0 p-m-0">{{ program.label }}</span>

					<div v-if="program.selectedAddons !== null">
						<div v-for="addon in program.selectedAddons" :key="addon.id">
							<span class="p-p-0 p-m-0">+ {{ addon.label }}</span>
						</div>
					</div>
				</div>
			</div>

			<div
				v-if="
					store.Waivers.waiversDone &&
					entry.programPermission &&
					entry.mediaReleasePermission
				"
			>
				<div>Program Permissions: {{ entry.programPermission.key }}</div>

				<div>
					Media Release Permissions:
					{{ entry.mediaReleasePermission.key }}
				</div>
			</div>
		</div>

		<div class="p-d-flex p-flex-column">
			<h4 class="p-text-bold p-mt-3 p-mb-0">Parent Information</h4>

			<div
				v-for="parent in store.ParentInformation"
				:key="parent.parentNumber"
				class="p-mb-2"
			>
				<div class="p-text-bold">
					{{ parent.firstName }}
					{{ parent.lastName }}
				</div>
				<div>{{ parent.phone }}</div>
				<div>{{ parent.email }}</div>
				<div>{{ parent.relationship }}</div>
			</div>

			<h4 class="p-text-bold p-mt-3 p-mb-0">Emergency Contact Information</h4>

			<div
				v-for="(emergencyContact, index) in store.EmergencyContactInfo"
				:key="index"
				class="p-mb-2"
			>
				<div class="p-text-bold">
					{{ emergencyContact.firstName }}
					{{ emergencyContact.lastName }}
				</div>
				<div>{{ emergencyContact.phone }}</div>
				<div>{{ emergencyContact.email }}</div>
				<div>{{ emergencyContact.relationship }}</div>
			</div>
		</div>
	</div>
</template>
<script>
import { useFormDataStore } from "@/store/formData";
import useVuelidate from "@vuelidate/core";

export default {
	name: "Summary",
	data() {
		return {
			isMobile: false,
		};
	},
	setup() {
		const store = useFormDataStore();

		return {
			store,
			v$: useVuelidate,
		};
	},
	async mounted() {
		this.getScreenSize();
	},
	methods: {
		getScreenSize() {
			if (window.innerWidth < 1001) {
				this.isMobile = true;
			} else {
				this.isMobile = false;
			}

			window.addEventListener("resize", this.myEventHandler);
		},
		myEventHandler() {
			if (window.innerWidth < 1001) {
				this.isMobile = true;
			} else {
				this.isMobile = false;
			}
		},
	},
};
</script>
